/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MagicTokenResponse
 */
export interface MagicTokenResponse {
    /**
     * The e-mail address the magic token was sent to.
     * @type {string}
     * @memberof MagicTokenResponse
     */
    userEmail: string;
    /**
     * The status of the magic token request.
     * @type {string}
     * @memberof MagicTokenResponse
     */
    status: string;
}

/**
 * Check if a given object implements the MagicTokenResponse interface.
 */
export function instanceOfMagicTokenResponse(value: object): value is MagicTokenResponse {
    if (!('userEmail' in value) || value['userEmail'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MagicTokenResponseFromJSON(json: any): MagicTokenResponse {
    return MagicTokenResponseFromJSONTyped(json, false);
}

export function MagicTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userEmail': json['userEmail'],
        'status': json['status'],
    };
}

export function MagicTokenResponseToJSON(json: any): MagicTokenResponse {
    return MagicTokenResponseToJSONTyped(json, false);
}

export function MagicTokenResponseToJSONTyped(value?: MagicTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEmail': value['userEmail'],
        'status': value['status'],
    };
}

